import type { ReactElement } from 'react';
import { RouterProvider } from 'react-router';
import { AppProviders } from './providers';
import { router } from './routes';

export const App = (): ReactElement => (
  <AppProviders>
    <RouterProvider router={router} />
  </AppProviders>
);
